import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7934d28e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { ref: "message" }
const _hoisted_3 = { class: "main-layout" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "flex col" }
const _hoisted_6 = { class: "flex justify-between wrap" }
const _hoisted_7 = { class: "flex justify-center align-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","margin-left":"50px","margin-top":"-10px"},
  width: "24",
  height: "24",
  src: "/ico/edit-picture.svg"
}, null, -1))
const _hoisted_9 = {
  style: {"object-fit":"cover","width":"100%","height":"100%","border-radius":"6px"},
  ref: "picture",
  src: "/ico/equipement.svg"
}
const _hoisted_10 = { class: "edit-btn" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "flex justify-center align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_StockImagePicker = _resolveComponent("StockImagePicker")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_LockedField = _resolveComponent("LockedField")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_DatabaseModuleTab = _resolveComponent("DatabaseModuleTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Illustration",
      ref: "illustrationModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          value: _ctx.state.element!.name,
          inputChange: _ctx.onNameChange
        }, null, 8, ["value", "inputChange"]),
        _createVNode(_component_StockImagePicker, {
          select: _ctx.pickStockImageIllustration,
          ref: "stockImages"
        }, null, 8, ["select"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SeButton, {
            icon: "ico/edit-picture.svg",
            onPress: _ctx.pickIllustration
          }, {
            default: _withCtx(() => [
              _createTextVNode("Pick file")
            ]),
            _: 1
          }, 8, ["onPress"]),
          _createVNode(_component_SeButton, { onPress: _ctx.closeIllustrationModal }, {
            default: _withCtx(() => [
              _createTextVNode("Close")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "modal",
      title: "Informations"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, null, 512)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "typeModal",
      title: _ctx.Lang.getI18N('edit')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeForm, {
          ref: "typeForm",
          class: "flex col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SeInput, {
              ref: "typeName",
              value: "",
              placeholder: _ctx.Lang.getI18N('name'),
              required: ""
            }, null, 8, ["placeholder"]),
            _createVNode(_component_SeButton, {
              class: "modal-valid w100",
              onPress: _ctx.createOrEditType
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ok")
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.state.element!.name
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.element!.illustration_lock,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.element!.illustration_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openIllustrationModal && _ctx.openIllustrationModal(...args))),
                    class: "img-container"
                  }, [
                    _hoisted_8,
                    _createElementVNode("img", _hoisted_9, null, 512)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.element!.name_lock,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.element!.name_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SeInput, {
                    ref: "name",
                    style: {"width":"400px","max-width":"60vw"},
                    modelValue: _ctx.state.element!.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.element!.name) = $event)),
                    placeholder: "Name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.element!.type_lock,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.element!.type_lock) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SeDropdown, {
                    modelValue: _ctx.state.selectedType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.selectedType) = $event)),
                    titleFunc: (type) => type.name.trim(),
                    ref: "typeSelect"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.types, (type) => {
                        return (_openBlock(), _createBlock(_component_SeDropdownItem, { value: type }, {
                          tailing: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_SeImage, {
                                onClick: () => _ctx.openEditTaskTypeModal(type),
                                maxWidth: 18,
                                maxHeight: 18,
                                src: "/ico/edit-blue.svg"
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 256)),
                      _createVNode(_component_SeDropdownItem, {
                        displayTitle: false,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openTypeModalCreation())),
                        class: "noselect"
                      }, {
                        heading: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "titleFunc"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_LockedField, {
                modelValue: _ctx.state.element!.active_lock,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.element!.active_lock) = $event)),
                style: {"background-color":"white","border-radius":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ToggleSwitch, {
                    modelValue: _ctx.state.element!.active,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.element!.active) = $event)),
                    auto: "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!_ctx.state.creation)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 0,
                    onPress: _ctx.clone,
                    ref: "cloneBtn",
                    icon: "ico/copy.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SeButton, {
                tooltip: _ctx.Lang.getI18N('save'),
                onPress: _ctx.apply,
                ref: "applyBtn",
                icon: "ico/save.svg"
              }, null, 8, ["tooltip", "onPress"])
            ])
          ])
        ]),
        _createVNode(_component_DatabaseModuleTab, {
          ref: "moduleTab",
          databaseId: _ctx.state.getDatabaseId(),
          element: _ctx.state.element!
        }, null, 8, ["databaseId", "element"])
      ])
    ])
  ], 64))
}